export const GlobalSearch = {
    state: {
        selectedItem: null,
        showDocumentsView: false,
        globalSearchText: "",
        isolatedTypes: [],
    },
    mutations: {
        SET_SELECTED_ITEM (state, value) {
            state.selectedItem = value;
        },
        SET_SHOW_DOCUMENTS_SECTION (state, value) {
            state.showDocumentsView = value;
        },
        SET_GLOBAL_SEARCH_TEXT (state, value) {
            state.globalSearchText = value;
        },
        SET_ISOLATED_TYPES: (state, value) => {
            state.isolatedTypes = value;
        }
    },
    actions: {
        
    },
    getters: {
        GET_SELECTED_ITEM (state) {
            return state.selectedItem;
        },
        GET_SHOW_DOCUMENTS_SECTION (state) {
            return state.showDocumentsView;
        },
        GET_GLOBAL_SEARCH_TEXT (state) {
            return state.globalSearchText;
        },
        GET_ISOLATED_TYPES: (state) => {
            return state.isolatedTypes;
        }
    },
}